import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Session from "../utils/sessionStorage";
import axiosInstance from "../utils/axiosInstance";
import AuthModal from "../components/AuthModal";

const Auth = () => {
  const [showAuthModal, setShowAuthModal] = useState(true);
  const [isErrMsg, setIsErrMsg] = useState(false);
  const [errMsg, setErrMsg] = useState(null);
  const [isPromptModalShows, setIsPromptModalShows] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getAuthParams();
  }, []);

 /* const getAuthParams = async () => {
    try {
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const searchParams = new URLSearchParams(url.search);
      const walletUserSessToken = searchParams.get("WalletUserSessToken");
      const consentTokenVal = Session.get("_consent_Tkn");
      // Ensure WalletUserSessToken is available
      if (!walletUserSessToken) {
        setErrMsg("Missing WalletUserSessToken in the URL");
        setIsErrMsg(true);
        return;
      }
      let body;

      if (consentTokenVal) {
        // API call with consent token
        body = {
          walletUserSessToken: walletUserSessToken,
          consentToken: consentTokenVal,
        };
      } else {
        body = {
          walletUserSessToken: walletUserSessToken,
        };
      }
      const response = await axiosInstance.post("api/v1/get-user-info", body);
      const { userInfo } = response?.data;

      if (userInfo) {
        setIsErrMsg(false);
        setErrMsg(false);

        const { customerType } = userInfo;
        if (customerType === "NoCDD") {
          const { fullName, email, mobileNo } = userInfo;
          const userData = {
            fullName,
            email,
            mobileNo,
            customerType,
          };
          Session.set("_user_", JSON.stringify(userData));
          navigate("/home");
        } else {
          const {
            consentStatus,
            redirectUrl,
            consentToken,
            fullName,
            firstName,
            lastName,
            email,
            mobileNo,
            token,
            identityNo,
            identityType,
            nationality,
            entityId,
            entityCif,
            identityDocExpiry,
            dob,
          } = userInfo;
          const userData = {
            firstName: firstName,
            lastName: lastName,
            fullName: fullName,
            email: email,
            mobileNo: mobileNo,
            identityNo: identityNo,
            identityType: identityType,
            nationality: nationality,
            entityId: entityId,
            entityCif: entityCif,
            identityDocExpiry: identityDocExpiry,
            dob: dob,
            customerType: customerType,
          };

          Session.set("_user_", JSON.stringify(userData));
          Session.set("_consent_Tkn", consentToken);
          Session.set("walletUserSess", walletUserSessToken);
          Session.set("status", consentStatus);
          // if (consentStatus !== "APPR") {
          //   Session.set("token", token);
          // }
          Session.set("token", token);
          if (consentStatus !== "APPR") {
            window.location.href = redirectUrl;
          } else {
            navigate("/home");
          }
        }
      }
    } catch (error) {
      setIsErrMsg(true);
      // Handle different error cases
      if (error.response) {
        // Server responded with a status outside the 2xx range
        const message =
          error.response.data?.message ||
          `Server error: ${error.response.status}`;
        setErrMsg(message);
      } else if (error.request) {
        // No response received
        setErrMsg("No response from the server. Please check your connection.");
      } else {
        // Something else caused the error
        setErrMsg("An unexpected error occurred. Please try again later.");
      }
    }
  };*/

  const getAuthParams = async () => {
    try {
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const searchParams = new URLSearchParams(url.search);
      const walletUserSessToken = searchParams.get("WalletUserSessToken");
      const consentTokenVal = Session.get("_consent_Tkn");

      //console.log("Consent Token: ", consentTokenVal);

  
      // Ensure WalletUserSessToken is available
      if (!walletUserSessToken) {
        setErrMsg("Missing WalletUserSessToken in the URL");
        setIsErrMsg(true);
        return;
      }

      let body;
      if (consentTokenVal) {
        // API call with consent token
        body = {
          walletUserSessToken: walletUserSessToken,
          consentToken: consentTokenVal,
        };
      } else {
        body = {
          walletUserSessToken: walletUserSessToken,
        };
      }

      console.log("Request Body: ", body);

      const response = await axiosInstance.post("api/v1/get-user-info", body);

      console.log("API Response: ", response?.data);

      const { userInfo } = response?.data;

      if (userInfo) {
        setIsErrMsg(false);
        setErrMsg(false);

        const { customerType } = userInfo;
        const avaNumbers = Array.isArray(userInfo.s4sNumbers) && userInfo.s4sNumbers.length > 0
          ? userInfo.s4sNumbers.map((numberInfo) => numberInfo.MSISDN).filter(Boolean)
          : [];

        if (customerType === "NoCDD") {
          const { fullName, email, mobileNo, walletId } = userInfo;
          const userData = {
            fullName,
            email,
            mobileNo,
            customerType,
            walletId

          };
          Session.set("_user_", JSON.stringify(userData));
          Session.set("avaNumbers", JSON.stringify(avaNumbers));
          Session.set("walletUserSess", walletUserSessToken);
          
          // Clear any existing consent verification since user is coming from auth
          sessionStorage.removeItem('consentVerified');
          sessionStorage.removeItem('lastConsentCheck');
          
          // Navigate with state indicating user is coming from auth
          navigate("/home", { state: { fromAuth: true } });
        } else {
          const {
            consentStatus,
            redirectUrl,
            consentToken,
            fullName,
            firstName,
            lastName,
            email,
            mobileNo,
            token,
            identityNo,
            identityType,
            nationality,
            entityId,
            entityCif,
            identityDocExpiry,
            dob,
            saOrgName,
            saOrgId,
            walletId,
          } = userInfo;

          const userData = {
            firstName,
            lastName,
            fullName,
            email,
            mobileNo,
            identityNo,
            identityType,
            nationality,
            entityId,
            entityCif,
            identityDocExpiry,
            dob,
            customerType,
            saOrgName,
            saOrgId,
            walletId,
          };

          Session.set("_user_", JSON.stringify(userData));
          Session.set("avaNumbers", JSON.stringify(avaNumbers));
          Session.set("_consent_Tkn", consentToken);
          Session.set("walletUserSess", walletUserSessToken);
          Session.set("status", consentStatus);
          //if (token){
           // Session.set("token", token);

          //}

          Session.set("token", token);


          if (consentStatus !== "APPR") {
            window.location.href = redirectUrl;
          } else {
            // Clear any existing consent verification since user is coming from auth
            sessionStorage.removeItem('consentVerified');
            sessionStorage.removeItem('lastConsentCheck');
            
            // Navigate with state indicating user is coming from auth
            navigate("/home", { state: { fromAuth: true } });
          }
        }
      }
    } catch (error) {
      setIsErrMsg(true);
      // Handle different error cases
      if (error.response) {
        const message =
          error.response.data?.message ||
          `Server error: ${error.response.status}`;
        setErrMsg(message);
      } else if (error.request) {
        setErrMsg("No response from the server. Please check your connection.");
      } else {
        setErrMsg("An unexpected error occurred. Please try again later.");
      }
    }
  };
  

  return (
    <div className="container">
      {showAuthModal && <AuthModal isErrMsg={isErrMsg} errMsg={errMsg} />}
    </div>
  );
};

export default Auth;
